import { Save } from 'lucide-react';

// Save state as a disk icon plus the last saved time (#275). While a save is
// in flight only the icon's colour changes (muted -> accent), so nothing
// shifts; a "Saving..." label used to appear and push the layout around.
// Renders nothing until there is a saved time or a save in progress, unless
// `always` is set (places with no saved time, e.g. the task modal).

interface Props {
  lastSaved?: string | null;
  saving?: boolean;
  /** Show the idle icon even before anything has been saved. */
  always?: boolean;
  iconSize?: number;
  className?: string;
}

export function SaveStatus({ lastSaved, saving = false, always = false, iconSize = 10, className = '' }: Props) {
  if (!lastSaved && !saving && !always) return null;
  return (
    <span
      className={`flex items-center gap-1 text-xs text-text-muted whitespace-nowrap ${className}`}
      data-testid="save-status"
      data-saving={saving ? 'true' : 'false'}
    >
      <Save
        size={iconSize}
        aria-hidden="true"
        data-testid="save-icon"
        className={`flex-shrink-0 transition-colors ${saving ? 'text-accent' : 'text-text-muted'}`}
      />
      {lastSaved && <span title={`Saved ${lastSaved}`}>{lastSaved}</span>}
      <span className="sr-only" role="status">{saving ? 'Saving' : ''}</span>
    </span>
  );
}
